import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ReserveSuggesterDto, ReserveSuggestionResponseDto
} from '@secca/case/components/case-plans/case-plans/add-service-order/models/ReserveSuggesterLineDto';
import { SettingsService } from '@secca/core/services/settings.service';
import { KeycloakService } from 'keycloak-angular';
import { EventSourcePolyfill } from 'event-source-polyfill';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService extends BaseService {
  private readonly reserveSuggesterUrl = 'suggestion/reserve';
  private readonly suggesterUrl = 'suggestion';
  private eventSource!: EventSource;


  constructor(
    private httpClient: HttpClient,
    private keycloakService: KeycloakService,
    private settingsService: SettingsService) {
    super(settingsService);
  }

  reserveSuggestion(serviceOrderDto: ReserveSuggesterDto): Observable<ReserveSuggestionResponseDto> {
    return this.httpClient.post<ReserveSuggestionResponseDto>(this.baseURL + this.reserveSuggesterUrl, serviceOrderDto, {
      headers: this.jsonHeaders
    });
  }

  reserveSuggestionResult(sseId: string): Observable<string> {
    const token = this.keycloakService.getKeycloakInstance().token;
    return new Observable(observer => {
      const url = this.baseURL + this.reserveSuggesterUrl + '/subscription/' + sseId;
      this.eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      this.eventSource.onmessage = (event) => {
        console.log('Received event:', event.data);
        observer.next(event.data);
        this.eventSource.close();
        observer.complete();
      };

      this.eventSource.onerror = (error) => {
        console.error('EventSource error:', error);
        observer.error(error);
        this.eventSource.close();
      };

      return () => {
        this.eventSource.close();
      };
    });
  }
}
